import { takeLatest, put, call, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { getImpulseOrderById, getOrderById } from 'yoda-interfaces/lib/Account/AccountApi';
import FSaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { doPostSSRLogs, isFeatureEnabled } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectContext } from 'yoda-site-components/lib/selectors/ContextSelector';
import { TRACK_UPDATE_PAYMENT_SLIDER_ON_LOAD } from 'yoda-account-components/lib/actionTypes/UpdatePaymentActionTypes';
import BuildOrderDetailsSaga from 'yoda-account-components/lib/sagas/BuildOrderDetailsSaga';
import {
    GET_ORDER_DETAIL,
    GET_ORDER_DETAIL_LOADING_STOP,
    GET_ORDER_DETAIL_SUCCESS,
    GET_ORDER_DETAIL_ERROR,
} from '../actionTypes/OrderDetailsActionTypes';
import ApplicationLogger from '../helpers/ApplicationLogger';

const context = (state) => state.context;
const getOrderDetailsPayload = (state) => state.orderDetails;
const getUpdatePaymentPayload = (state) => state.updatePaymentDetails;

function* OrderDetailsSaga(action) {
    const logger = ApplicationLogger.getLogger();
    const cookies = get(action, 'headers.cookies', {});
    let ssrData = {};
    let ssrSuccessful = false;

    try {
        let orderDetailsHistory = {};
        const appContext = yield select(context);
        const { featureFlags = {}, preferences = {}, headers = {} } = appContext || {};
        const { getOrderDetailsFromImpulse = true, enableCurbsidePickup = true } = featureFlags;
        const getOrderDetailsFromImpulseEnabled = isFeatureEnabled(
            { getOrderDetailsFromImpulse },
            preferences,
            headers,
            'getOrderDetailsFromImpulse',
            'X-GET-ORDER-DETAILS-IMPULSE',
            'X-GET-ORDER-DETAILS-IMPULSE'
        );
        const isCurbsideEnabled = isFeatureEnabled(
            { enableCurbsidePickup },
            preferences,
            headers,
            'enableCurbsidePickup',
            'DP_ENABLE_CURBSIDE_PICKUP',
            'X-ENABLE-CURBSIDE-PICKUP'
        );
        const orderDetails = yield select(getOrderDetailsPayload);
        const updatePaymentDetails = yield select(getUpdatePaymentPayload);
        if (
            !action.payload.skipReduxCache &&
            get(orderDetails.payload, 'id') &&
            action.payload.token === get(orderDetails.payload, 'id')
        ) {
            yield put({ type: GET_ORDER_DETAIL_LOADING_STOP, payload: orderDetails.payload });
            return;
        }

        const getOrderByIdApi = getOrderDetailsFromImpulseEnabled
            ? getImpulseOrderById
            : getOrderById;

        orderDetailsHistory = yield call(FSaga, getOrderByIdApi, action, undefined, false);
        ssrSuccessful = orderDetailsHistory.isSuccess;
        if (orderDetailsHistory.isSuccess) {
            let aggregatedOrder;
            if (getOrderDetailsFromImpulseEnabled) {
                aggregatedOrder = yield call(
                    BuildOrderDetailsSaga,
                    orderDetailsHistory,
                    action,
                    isCurbsideEnabled
                );
            } else {
                aggregatedOrder = orderDetailsHistory;
            }
            yield put({ type: GET_ORDER_DETAIL_SUCCESS, payload: aggregatedOrder });
        } else {
            const orderDetailsResponse = get(orderDetailsHistory, 'response.data');
            const orderDetailsError = Array.isArray(orderDetailsResponse)
                ? orderDetailsResponse[0]
                : orderDetailsResponse;
            yield put({ type: GET_ORDER_DETAIL_ERROR, error: orderDetailsError });
        }
        ssrData = orderDetailsHistory.response;
        if (
            (orderDetailsHistory.isSuccess &&
                updatePaymentDetails.showUpdatePaymentSlider &&
                updatePaymentDetails.source === 'orderlist') ||
            action.payload.action === 'paymentUpdate'
        ) {
            yield put({
                type: TRACK_UPDATE_PAYMENT_SLIDER_ON_LOAD,
                payload: updatePaymentDetails.source || 'orderlist',
            });
        }
    } catch (error) {
        const errorPayload = {
            errorMessage: error.message,
            errorCode: 'EXCEPTION_IN_ORDER_DETAILS_SAGA',
        };
        yield put({
            type: GET_ORDER_DETAIL_ERROR,
            error: errorPayload,
        });
        ssrData.data = errorPayload;
    }
    const { cluster } = yield select(selectContext);
    __SERVER__ &&
        doPostSSRLogs(
            logger,
            {
                requestInfo: `IS ORDER DETAILS PAGE RENDERED ON SERVER SIDE : ${ssrSuccessful}`,
                response: ssrData,
            },
            cookies,
            cluster
        );
}

function* watchOrderDetailsSaga() {
    yield takeLatest(GET_ORDER_DETAIL, OrderDetailsSaga);
}

watchOrderDetailsSaga.sagaName = 'orderDetailsSaga';
export default watchOrderDetailsSaga;
